import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatNumber } from '../../helpers/FormatNumber/formatNumber';

// Translation
import { injectIntl, FormattedNumber } from 'react-intl';

// Helper
import { convert, getCurrencySymbol } from '../../helpers/currencyConvertion';
import { isRTL } from '../../helpers/formatLocale';

const CurrencyConverter = (props) => {
  const { from, amount = 0, base, rates, superSymbol = false, className, toCurrency, locale, isCurrency, intl, isDashboard = false } = props;
  const [currencyBase, setCurrencyBase] = useState(null);
  const [currencyRates, setCurrencyRates] = useState(null);

  useEffect(() => {
    if (base !== undefined && rates !== undefined) {
      setCurrencyBase(base);
      setCurrencyRates(rates);
    }
  }, [base, rates]);

  const fromCurrency = from || currencyBase;
  const finalToCurrency = toCurrency || currencyBase || 'USD';

  let convertedAmount = amount;
  if (currencyRates != null) {
    convertedAmount = convert(currencyBase, currencyRates, amount, fromCurrency, finalToCurrency);
  }

  const shouldOmitDecimals = convertedAmount % 1 === 0;
  const fractionDigits = {
    minimumFractionDigits: shouldOmitDecimals ? 0 : 2,
    maximumFractionDigits: shouldOmitDecimals ? 0 : 2
  };
  let currencySymbol = getCurrencySymbol(finalToCurrency)
  const isAbbreviated = isDashboard && Math.abs(convertedAmount) >= 1000;
  return (
    <span className={className}>
      {
        isAbbreviated ? (
          <>
            {isRTL(locale) ? (
              <>
                {formatNumber(convertedAmount)}{' '}
                {currencySymbol}
              </>
            ) : (
              <>
                {currencySymbol}{' '}
                {formatNumber(convertedAmount)}
              </>
            )}
          </>
        ) : (
          isRTL(locale) && finalToCurrency ? (
            new Intl.NumberFormat('en-US', {
              style: "currency",
              currency: finalToCurrency,
              ...fractionDigits,
              currencyDisplay: "symbol"
            }).format(convertedAmount)
          ) : (
            <FormattedNumber
              value={convertedAmount}
              style="currency"
              currency={finalToCurrency}
              {...fractionDigits}
              currencyDisplay="symbol"
            />
          )
        )}
      {
        superSymbol && <sup>{finalToCurrency}</sup>
      }
    </span>
  );
};

CurrencyConverter.propTypes = {
  from: PropTypes.string,
  amount: PropTypes.number,
  base: PropTypes.string,
  rates: PropTypes.object,
  superSymbol: PropTypes.bool,
  className: PropTypes.string,
  toCurrency: PropTypes.string,
  locale: PropTypes.string,
  isCurrency: PropTypes.bool,
  intl: PropTypes.object.isRequired
};

const mapState = (state) => ({
  base: state.currency.base,
  toCurrency: state.currency.to,
  rates: state.currency.rates,
  locale: state.intl.locale
});

export default injectIntl(connect(mapState)(CurrencyConverter));
